// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0b89fadf","239":"aaf0ad36","455":"cef27860"}[chunkId] + ".chunk.js";
};